import axios from 'axios';

import { AddLeadDto } from '../interfaces/add-lead-manually.interface';

class LeadsService {
  async add(data: AddLeadDto): Promise<void> {
    return await axios.post('leads', data);
  }

  async addSilent(data: AddLeadDto): Promise<{ inquiryId: string }> {
    const response = await axios.post<{ inquiryId: string }>('leads/silent', data);
    return response.data;
  }
}

export default new LeadsService();
